customElements.get("scroll-active") || customElements.define("scroll-active", class extends HTMLElement {
  constructor() {
    super(), this.mq = window.matchMedia("(max-width: 1024px)"), this.checkScrollable = this.checkScrollable.bind(this);
  }
  checkScrollable() {
    const e = this.firstElementChild;
    if (!e || e.scrollWidth <= e.clientWidth) return;
    const t = e.querySelector("[data-active]") || this.querySelector("[data-active]");
    if (!t) return;
    const {left: c, width: l} = e.getBoundingClientRect(), {left: i, width: s} = t.getBoundingClientRect();
    e.scrollLeft = Math.max(0, i - c + e.scrollLeft - (l - s) / 2);
  }
  connectedCallback() {
    this.querySelector("[data-active]") && (this.checkScrollable(), this.mq.addEventListener("change", this.checkScrollable));
  }
  disconnectedCallback() {
    this.mq.removeEventListener("change", this.checkScrollable);
  }
});